<div class="consent-screen-main-container text">
  <div class="header-container">{{ 'Consent_checkbox_text_8' | translate }} {{ this._UserHelper.customerUser?.CustomerName }}</div>
  <div class="consent-screen-text-container">
    <div class="info-container">
      {{ 'Consent_checkbox_text_3' | translate }}
      <div>
        <form [formGroup]="consentScreenForm">
          <div class="checkbox-container">
            <!-- I have read and accepted the Terms and Conditions. -->
            <div class="checkbox-container-item">
              <input
                class="checkbox_with_label"
                type="checkbox"
                id="terms_conditions"
                name="terms_conditions"
                required="{{ 'Required' | translate }}"
                formControlName="terms_conditions" />
              <span class="input-span">
                <label for="terms_conditions">
                  {{ 'Consent_checkbox_text_1' | translate }}
                  <a class="item2" routerLink="/article/{{ 'route_article_footer_5' | translate }}" target="_blank">{{ 'Consent_checkbox_text_S1' | translate }}</a>

                  {{ 'Consent_checkbox_text_S2' | translate }}
                </label>
              </span>
            </div>
            <div class="checkbox-container-item">
              <input class="checkbox_with_label" type="checkbox" id="privacy" name="privacy" required="{{ 'Required' | translate }}" formControlName="privacy" />

              <span class="input-span">
                <label for="privacy">
                  {{ 'Consent_checkbox_text_2_1' | translate }}
                  <a class="item2" routerLink="/article/{{ 'route_article_footer_4' | translate }}" target="_blank">{{ 'Consent_checkbox_text_2_2' | translate }}</a
                  >{{ 'Consent_checkbox_text_2_3' | translate }}
                </label>
              </span>
            </div>
          </div>
          <div class="footer-container">
            <span>
              {{ 'Consent_checkbox_text_7_1' | translate }}
              <a href="mailto:{{ 'supportMail' | getEnv }}?Subject=Pay3000/{{ '' }}/{{ this._UserHelper?.customerUser?.UserName }}">
                {{ 'supportMail' | getEnv }}
              </a>
              {{ 'Consent_checkbox_text_7_3' | translate }}
            </span>
          </div>

          <div class="submit-wrap">
            <button [disabled]="!this.consentScreenForm.valid" type="submit" id="submitBtn" class="buttonSuccess" (click)="acceptConsent()">
              {{ 'Confirm' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
